var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdamam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 80",
    style: {
      enableBackground: "new 0 0 400 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#77CC00;}\r\n\t.st1{fill:#F4F7FA;}\r\n\t.st2{opacity:0.7;fill:#F4F7FA;}\r\n\t.st3{fill:#929497;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.9,42.5h-12.3c-0.8,0-1.4,0.1-1.4,0.9v7.5c0,0.8,0.6,1.4,1.4,1.4H225c0.8,0,1.4,0.6,1.4,1.4V54 c0,0.8-0.6,1.4-1.4,1.4h-16.3c-0.8,0-1.4-0.6-1.4-0.9V28.4c0-1.3,0.6-1.9,1.4-1.9h16.1c0.8,0,1.4,0.6,1.4,1.4v0.2 c0,0.8-0.6,1.4-1.4,1.4h-12.2c-0.8,0-1.4,0.6-1.4,1.4v7c0,0.8,0.6,1.4,1.4,1.4h12.3c0.8,0,1.4,0.6,1.4,1.4v0.2 C226.3,41.8,225.7,42.5,224.9,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.3,54V27.9c0-0.8,0.6-1.4,1.4-1.4h7.4c3.8,0,6.8,1.2,9.1,3.5c2.3,2.3,3.4,5.3,3.4,9v4 c0,3.7-1.1,6.7-3.4,9c-2.3,2.3-5.3,3.5-9.1,3.5h-7.4C232.9,55.4,232.3,54.8,232.3,54z M236.2,31v19.9c0,0.8,0.6,1.4,1.4,1.4h3.5 c2.7,0,4.8-0.9,6.3-2.6c1.5-1.8,2.3-4,2.3-6.8v-4c0-2.7-0.8-5-2.3-6.7c-1.5-1.8-3.7-2.6-6.3-2.6h-3.5 C236.9,29.5,236.2,30.2,236.2,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.6,48h-10.1c-0.6,0-1.1,0.4-1.4,0.9l-2,5.6c-0.2,0.6-0.7,0.9-1.4,0.9h-0.9c-1,0-1.7-1-1.3-2l10.1-26.1 c0.2-0.6,0.7-0.9,1.3-0.9h1.4c0.6,0,1.1,0.4,1.3,0.9l9.9,26.1c0.4,0.9-0.3,2-1.3,2h-0.9c-0.6,0-1.1-0.4-1.4-1l-2-5.6 C275.7,48.3,275.2,48,274.6,48z M266.7,44.7h5.6c1,0,1.7-1,1.4-1.9l-4.1-11.2h-0.1l-4.1,11.2C265,43.7,265.7,44.7,266.7,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.5,26.5c0.6,0,1.1,0.4,1.3,0.9l8.9,22.6h0.1l8.9-22.6c0.2-0.6,0.7-0.9,1.3-0.9h2.6c0.8,0,1.4,0.6,1.4,1.4 V54c0,0.8-0.6,1.4-1.4,1.4h-1c-0.8,0-1.4-0.6-1.4-1.4V44l0.4-11.8l-0.1,0l-9,22.3c-0.2,0.5-0.7,0.9-1.3,0.9h-0.7 c-0.6,0-1.1-0.4-1.3-0.9l-9-22.3l-0.1,0l0.4,11.7v10c0,0.8-0.6,1.4-1.4,1.4h-1c-0.8,0-1.4-0.6-1.4-1.4V27.9c0-0.8,0.6-1.4,1.4-1.4 H291.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339.5,48h-10.1c-0.6,0-1.1,0.4-1.4,0.9l-2,5.6c-0.2,0.6-0.7,0.9-1.4,0.9h-0.9c-1,0-1.7-1-1.3-2l10.1-26.1 c0.2-0.6,0.7-0.9,1.3-0.9h1.4c0.6,0,1.1,0.4,1.3,0.9l9.9,26.1c0.4,0.9-0.3,2-1.3,2h-0.9c-0.6,0-1.1-0.4-1.4-1l-2-5.6 C340.7,48.3,340.1,48,339.5,48z M331.7,44.7h5.6c1,0,1.7-1,1.4-1.9l-4.1-11.2h-0.1l-4.1,11.2C330,43.7,330.7,44.7,331.7,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.4,26.5c0.6,0,1.1,0.4,1.3,0.9l8.9,22.6h0.1l8.9-22.6c0.2-0.6,0.7-0.9,1.3-0.9h2.6c0.8,0,1.4,0.6,1.4,1.4 V54c0,0.8-0.6,1.4-1.4,1.4h-1c-0.8,0-1.4-0.6-1.4-1.4V44l0.4-11.8l-0.1,0l-9,22.3c-0.2,0.5-0.7,0.9-1.3,0.9h-0.7 c-0.6,0-1.1-0.4-1.3-0.9l-9-22.3l-0.1,0l0.4,11.7v10c0,0.8-0.6,1.4-1.4,1.4h-1c-0.8,0-1.4-0.6-1.4-1.4V27.9c0-0.8,0.6-1.4,1.4-1.4 H356.4z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 65.62 180.086)",
    className: "st0",
    cx: 167.6,
    cy: 40.9,
    rx: 28.6,
    ry: 28.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.7,29.5h-22.3c-0.7,0-1.3-0.6-1.3-1.3v-0.6c0-0.7,0.6-1.3,1.3-1.3h22.3c0.7,0,1.3,0.6,1.3,1.3v0.6 C180,29,179.4,29.5,178.7,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.7,42.5h-22.3c-0.7,0-1.3-0.6-1.3-1.3v-0.5c0-0.7,0.6-1.3,1.3-1.3h22.3c0.7,0,1.3,0.6,1.3,1.3v0.5 C180,41.9,179.4,42.5,178.7,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.7,55.4h-22.3c-0.7,0-1.3-0.6-1.3-1.3v-0.6c0-0.7,0.6-1.3,1.3-1.3h22.3c0.7,0,1.3,0.6,1.3,1.3v0.6 C180,54.9,179.4,55.4,178.7,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M162.9,36h-6.4c-0.7,0-1.3-0.6-1.3-1.3v-0.5c0-0.7,0.6-1.3,1.3-1.3h6.4c0.7,0,1.3,0.6,1.3,1.3v0.5 C164.2,35.4,163.6,36,162.9,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.1,49h-6.5c-0.7,0-1.3-0.6-1.3-1.3v-0.6c0-0.7,0.6-1.3,1.3-1.3h6.5c0.7,0,1.3,0.6,1.3,1.3v0.6 C164.3,48.4,163.8,49,163.1,49z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.5,50.4v4.2h-2V43.2h4.4c1.3,0,2.3,0.3,3,1c0.7,0.7,1.1,1.5,1.1,2.6c0,1.1-0.4,2-1.1,2.6 c-0.7,0.6-1.8,0.9-3.1,0.9H23.5z M23.5,48.8h2.4c0.7,0,1.2-0.2,1.6-0.5c0.4-0.3,0.6-0.8,0.6-1.4c0-0.6-0.2-1.1-0.6-1.5 s-0.9-0.6-1.5-0.6h-2.4V48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42,49.2c0,1.1-0.2,2.1-0.6,2.9c-0.4,0.8-0.9,1.5-1.7,1.9c-0.7,0.5-1.5,0.7-2.5,0.7c-0.9,0-1.7-0.2-2.5-0.7 c-0.7-0.5-1.3-1.1-1.7-1.9c-0.4-0.8-0.6-1.8-0.6-2.9v-0.6c0-1.1,0.2-2.1,0.6-2.9c0.4-0.8,0.9-1.5,1.7-1.9c0.7-0.5,1.5-0.7,2.5-0.7 c0.9,0,1.7,0.2,2.5,0.7c0.7,0.4,1.3,1.1,1.7,1.9s0.6,1.8,0.6,2.9V49.2z M40,48.6c0-1.3-0.2-2.2-0.7-2.9s-1.2-1-2-1 c-0.9,0-1.5,0.3-2,1c-0.5,0.7-0.7,1.6-0.7,2.8v0.7c0,1.2,0.2,2.2,0.7,2.9c0.5,0.7,1.2,1,2,1c0.9,0,1.5-0.3,2-1 c0.5-0.7,0.7-1.6,0.7-2.9V48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.1,51.8l1.8-8.6h2l-2.6,11.4h-1.9l-2.2-8.3l-2.2,8.3H47l-2.6-11.4h2l1.8,8.5l2.2-8.5h1.7L54.1,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.1,49.5h-4.7V53h5.5v1.6h-7.4V43.2h7.4v1.6h-5.4V48h4.7V49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.9,50.2h-2.2v4.4h-2V43.2h4c1.3,0,2.3,0.3,3,0.9c0.7,0.6,1.1,1.4,1.1,2.6c0,0.8-0.2,1.4-0.6,1.9 c-0.4,0.5-0.9,0.9-1.5,1.2l2.6,4.7v0.1h-2.1L74.9,50.2z M72.7,48.6h2c0.7,0,1.2-0.2,1.6-0.5s0.6-0.8,0.6-1.4 c0-0.6-0.2-1.1-0.5-1.4c-0.3-0.3-0.9-0.5-1.6-0.5h-2.1V48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.5,49.5h-4.7V53h5.5v1.6h-7.4V43.2h7.4v1.6h-5.4V48h4.7V49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M92.1,54.6V43.2h3.4c1,0,1.9,0.2,2.7,0.7c0.8,0.4,1.4,1.1,1.8,1.9c0.4,0.8,0.6,1.8,0.6,2.8v0.6 c0,1.1-0.2,2-0.6,2.8s-1,1.4-1.8,1.9c-0.8,0.4-1.7,0.7-2.7,0.7H92.1z M94.1,44.8V53h1.3c1,0,1.8-0.3,2.4-1s0.8-1.6,0.8-2.8v-0.6 c0-1.2-0.3-2.2-0.8-2.8c-0.5-0.7-1.3-1-2.3-1H94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.9,54.6V43.2h3.9c1.3,0,2.3,0.3,2.9,0.8s1,1.3,1,2.3c0,0.5-0.1,1-0.4,1.4s-0.7,0.7-1.2,1 c0.6,0.2,1.1,0.5,1.4,0.9s0.5,1,0.5,1.7c0,1.1-0.3,1.9-1,2.5c-0.7,0.6-1.7,0.9-2.9,0.9H108.9z M110.9,48h1.9 c0.6,0,1.1-0.1,1.4-0.4c0.3-0.3,0.5-0.7,0.5-1.2c0-0.6-0.2-1-0.5-1.2s-0.8-0.4-1.5-0.4h-1.9V48z M110.9,49.5V53h2.2 c0.6,0,1.1-0.2,1.5-0.5c0.3-0.3,0.5-0.7,0.5-1.3c0-1.2-0.6-1.8-1.8-1.8H110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.5,48.6l2.6-5.4h2.2l-3.8,7.2v4.2h-2v-4.2l-3.8-7.2h2.2L123.5,48.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdamam);
export default __webpack_public_path__ + "static/media/Edamam.ac5beb418eea50b75e77b8331145e92e.svg";
export { ForwardRef as ReactComponent };